/**
 * DrivingDistanceIcon — the "wheel + dashed route to a pin" glyph from the
 * SpotOn v0.2.1 design (`drivingFab`), used in place of Lucide's generic
 * `Car` for the Driving time tool. Built as a Lucide-shaped component
 * (same prop contract as `LucideIcon`) so it drops into `MapTool.icon`
 * without touching the registry's type.
 */
import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

export const DrivingDistanceIcon = forwardRef<SVGSVGElement, LucideProps>(
  function DrivingDistanceIcon(
    { size = 24, color = 'currentColor', strokeWidth = 1.7, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        className={className}
        {...rest}
      >
        <circle cx="6" cy="18" r="2.1" strokeWidth={strokeWidth} />
        <path
          d="M18 6.8a2.3 2.3 0 1 0-2.3 2.3c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6H8.6A2.6 2.6 0 0 0 6 16v0"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0.1 3.1"
        />
        <path
          d="M15.7 2.2c1.9 0 3.5 1.5 3.5 3.5 0 2.3-3.5 5.4-3.5 5.4S12.2 8 12.2 5.7c0-2 1.6-3.5 3.5-3.5Z"
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
